// File: packages/api-client/src/env.ts
// Version: 2026.8.1 | Required-environment-variable guard
// v2026.8.1: Initial. Replaces the hardcoded `|| 'https://…'` fallbacks that
//            used to sit in client.ts and each app's main.tsx.
//
// WHY NO DEFAULTS EXIST HERE
//   A fallback default is the branch that runs when configuration is ABSENT,
//   so it is the least-exercised value in the file and the first to go stale.
//   It then looks authoritative while being silently wrong. On 2026-08-31 the
//   fallback `|| 'api://c88de640-…'` in client.ts still named an Entra app
//   registration in a tenant Microsoft was deleting — and it was baked into a
//   shipped radar bundle. Config is now the single source of truth: a missing
//   variable fails loudly instead of resolving to a retired identity.
//
// CRITICAL — HOW TO CALL THIS
//   Vite replaces `import.meta.env.VITE_FOO` at BUILD time by literal pattern
//   match on the source text. A dynamic lookup (`import.meta.env[name]`) is
//   NOT replaced and is `undefined` in a production bundle. So this helper
//   takes the VALUE, read via a literal access at the call site, plus the name
//   for the message. Never refactor the call sites to pass only a name.
//
//       const audience = requiredEnv('VITE_API_AUDIENCE',
//                                     import.meta.env.VITE_API_AUDIENCE);

export function requiredEnv(name: string, value: string | undefined | null): string {
  if (value === undefined || value === null || value === '') {
    throw new Error(
      `[ForgeTrack] Missing required environment variable ${name}.\n` +
      `Set it in apps/<app>/.env.local for local dev, or as the GitHub secret ` +
      `injected by the deploy workflow.\n` +
      `There is deliberately no built-in default: a stale default (such as a ` +
      `retired Entra app id) ships silently and is indistinguishable from ` +
      `correct configuration at build time.`,
    );
  }
  return value;
}
